import { Build } from '@stencil/core';
// wird ignoriert, da nicht testbar! Die Deklaration eines Images kann im Test nicht gefunden werden.
// In Folge dessen ist hier so wenig wie möglich an Logik zu implementieren!
// prettier-ignore
/* istanbul ignore next */
export function createPixelLoader() {
  return {
    /** Erzeugt das Image */
    load: (picturePath, onLoad, onError) => {
      if (Build.isTesting) {
        if (picturePath.endsWith('?error')) {
          onError(new CustomEvent(''));
        }
        else {
          onLoad();
        }
        return;
      }
      const image = new Image();
      image.onload = onLoad;
      image.onerror = onError;
      image.src = `${picturePath}?${Date.now()}`;
    },
  };
}
//# sourceMappingURL=pixel.utils.js.map
